
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","height":"1086","fill":"none","viewBox":"0 0 711 1086"}},[_c('path',{attrs:{"fill":"#D5EBD2","d":"M710.5 475L-38.5 0-56 1085.5h547.5l219-610.5z"}})])
      }
    
      }
    